document.addEventListener("DOMContentLoaded", function () {
  const swiperContainers = document.querySelectorAll(".cards-carousel__swiper");
  swiperContainers.forEach(function (container) {
    const swiper = new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 12,
      speed: 500,
      navigation: {
        nextEl: container.querySelector(".cards-carousel__next"),
        prevEl: container.querySelector(".cards-carousel__prev")
      },
      pagination: {
        el: container.querySelector(".cards-carousel__pagination")
      },
      breakpoints: {
        640: {
          spaceBetween: 30
        }
      }
    });
  });

  // Logo Grid – Swiper only on mobile (< 768px)
  const logoGridContainers = document.querySelectorAll(".logo-grid__swiper");
  logoGridContainers.forEach(function (container) {
    let logoGridSwiper = null;
    const mobileQuery = window.matchMedia("(max-width: 767px)");
    function handleLogoGridSwiper(e) {
      if (e.matches && !logoGridSwiper) {
        logoGridSwiper = new Swiper(container, {
          slidesPerView: "auto",
          spaceBetween: 32,
          speed: 500,
          loop: true,
          centeredSlides: true,
          pagination: {
            el: container.querySelector(".logo-grid__pagination")
          },
          navigation: {
            nextEl: container.querySelector(".logo-grid__next"),
            prevEl: container.querySelector(".logo-grid__prev")
          }
        });
      } else if (!e.matches && logoGridSwiper) {
        logoGridSwiper.destroy(true, true);
        logoGridSwiper = null;
      }
    }
    handleLogoGridSwiper(mobileQuery);
    mobileQuery.addEventListener("change", handleLogoGridSwiper);
  });
  const testimonialsCarousels = document.querySelectorAll(".testimonials-carousel__content");
  testimonialsCarousels.forEach(function (container) {
    const swiper = new Swiper(container.querySelector(".swiper"), {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: container.querySelector(".testimonials-carousel__next"),
        prevEl: container.querySelector(".testimonials-carousel__prev")
      }
    });
  });
  const textCarouselImages = document.querySelectorAll(".text-carousel__images");
  textCarouselImages.forEach(function (container) {
    const swiper = new Swiper(container.querySelector(".swiper"), {
      effect: "fade",
      loop: true,
      pagination: {
        el: container.querySelector(".text-carousel__pagination")
      },
      navigation: {
        nextEl: container.querySelector(".text-carousel__next"),
        prevEl: container.querySelector(".text-carousel__prev")
      }
    });
  });
  const accordions = document.querySelectorAll(".map-accordion .accordion");
  accordions.forEach(accordion => {
    const button = accordion.querySelector(".accordion__button");
    const content = accordion.querySelector(".accordion__content");
    button.addEventListener("click", () => {
      const isOpen = content.style.maxHeight;
      accordions.forEach(acc => {
        acc.querySelector(".accordion__content").style.maxHeight = null;
        acc.querySelector(".accordion__button").classList.remove("active");
      });
      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 16 + "px";
        button.classList.add("active");
      }
    });
  });
  const galleryBlock = document.getElementsByClassName("gallery-images");
  if (galleryBlock.length) {
    Array.from(galleryBlock).forEach(function (block) {
      lightGallery(block, {
        selector: "a",
        plugins: []
        // Configurar para usar href en lugar de data-src
        // O agregar data-src a los elementos
      });
    });
  }
  const faqItems = document.querySelectorAll(".faq-item");
  faqItems.forEach(item => {
    const question = item.querySelector(".faq-question");
    question.addEventListener("click", () => {
      faqItems.forEach(i => {
        if (i !== item) {
          i.classList.remove("active");
        }
      });
      item.classList.toggle("active");
    });
  });
  let lastScrollTop = 0;
  let transitionEnabled = false;
  let isHeadierFixed = false;
  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScroll > 300 && window.innerWidth > 1024) {
      if (!isHeadierFixed) {
        const header = document.querySelector(".header");
        const headerHeight = header.offsetHeight;
        document.querySelector(".site-main").style.paddingTop = headerHeight + "px";
        isHeadierFixed = true;
      }
      document.body.classList.add("scrolled");

      // Activar transición solo si aún no lo hemos hecho
      setTimeout(() => {
        if (!transitionEnabled) {
          // Delay de un tick para evitar que la transición ocurra al entrar a .scrolled
          requestAnimationFrame(() => {
            document.body.classList.add("enable-transition");
            transitionEnabled = true;
          });
        }
      }, 400);
    } else {
      document.body.classList.remove("scrolled");
      document.body.classList.remove("enable-transition");
      transitionEnabled = false;
      document.querySelector(".site-main").style.paddingTop = "0";
      isHeadierFixed = false;
    }

    // --- DIRECCIÓN DEL SCROLL ---
    if (currentScroll > lastScrollTop) {
      document.body.classList.add("scroll-down");
      document.body.classList.remove("scroll-up");
    } else {
      document.body.classList.add("scroll-up");
      document.body.classList.remove("scroll-down");
    }
    lastScrollTop = Math.max(currentScroll, 0);
  });
});
const megaMenuPosition = () => {
  const megaMenuContainer = document.querySelectorAll(".header-nav > li.menu-item-has-children.active .mega-menu-container:not(.mega-menu-container--tabs)");
  megaMenuContainer.forEach(container => {
    const xPosition = container.parentElement.getBoundingClientRect().left;
    const menuOffset = xPosition + window.scrollX;
    const menuWidth = container.offsetWidth;
    console.log("Menu Offset:", menuOffset);
    console.log("Menu Width:", menuWidth);
    const viewportWidth = window.innerWidth;
    if (menuOffset + menuWidth > viewportWidth) {
      container.style.marginLeft = "-" + (menuOffset + menuWidth - viewportWidth + 20) + "px";
    } else {
      container.style.marginLeft = "0px";
    }
  });
};
document.addEventListener("DOMContentLoaded", function () {
  const mainNavLinks = document.querySelectorAll(".header-nav > li.menu-item-has-children");
  mainNavLinks.forEach(link => {
    link.querySelector("a").addEventListener("click", function (e) {
      e.preventDefault();
      mainNavLinks.forEach(otherLink => {
        if (otherLink !== link) {
          otherLink.classList.remove("active");
        }
      });
      link.classList.toggle("active");
      megaMenuPosition();
    });
  });

  // Handle click outside
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".header-nav")) {
      mainNavLinks.forEach(link => {
        link.classList.remove("active");
      });
    }
  });
  const megaMenutabs = document.querySelectorAll(".mega-menu-container__tabs-nav li");
  megaMenutabs.forEach(tab => {
    const thisIndex = Array.from(megaMenutabs).indexOf(tab);
    if (thisIndex === 0) {
      tab.classList.add("active");
    }
    tab.addEventListener("mouseenter", function () {
      const thisDataContent = this.getAttribute("data-content");
      const allTabContents = document.querySelectorAll(".mega-menu-container__tabs-content-item");
      allTabContents.forEach(content => {
        if (content.id === thisDataContent) {
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
      });
      megaMenutabs.forEach(otherTab => {
        if (otherTab !== tab) {
          otherTab.classList.remove("active");
        }
      });
      this.classList.toggle("active");
    });
  });
  const mobileNavTogle = document.getElementById("mobile-nav-toggle");
  const body = document.body;
  if (mobileNavTogle) {
    mobileNavTogle.addEventListener("click", function () {
      if (body.classList.contains("mobile-nav-open")) {
        body.classList.remove("mobile-nav-open");
        setTimeout(() => {
          body.classList.remove("animated-nav");
          document.querySelectorAll(".mobile-menu-normal__list > li").forEach(accordion => {
            accordion.classList.remove("expanded");
          });
        }, 600);
      } else {
        body.classList.add("animated-nav");
        body.classList.add("mobile-nav-open");
      }
    });
  }
  const mobileNavAccordion = document.querySelectorAll(".mobile-menu-normal__list > li.menu-item-has-children > a");
  mobileNavAccordion.forEach(accordion => {
    accordion.addEventListener("click", function (e) {
      e.preventDefault();
      const parentItem = accordion.parentElement;
      parentItem.classList.toggle("expanded");
      if (parentItem.classList.contains("expanded")) {
        const mainView = document.querySelector(".mobile-menu-main-view");
        if (mainView) {
          mainView.scrollTo({
            top: parentItem.offsetTop,
            behavior: "smooth"
          });
        }
      }
    });
  });
  const featuredItems = document.querySelectorAll(".mobile-featured-item");
  if (featuredItems) {
    featuredItems.forEach(item => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        const target = item.getAttribute("data-target");
        document.querySelectorAll(".mobile-menu-featured-children").forEach(view => {
          view.style.display = "none";
        });
        document.getElementById(target).style.display = "flex";
        document.querySelector(".mobile-menu-secondary-view").classList.add("open");
      });
    });
  }
  const backToMainMenuBtn = document.querySelector(".mobile-menu-secondary-view__back");
  if (backToMainMenuBtn) {
    backToMainMenuBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelectorAll(".mobile-menu-featured-children").forEach(view => {
        view.style.display = "none";
      });
      document.querySelector(".mobile-menu-secondary-view").classList.remove("open");
    });
  }
  document.getElementById("header-search-trigger").addEventListener("click", function () {
    body.classList.add("header-search-open");
    setTimeout(() => {
      body.classList.add("header-search-expanded");
      document.querySelector("#header-search-form-wrapper input").focus();
    }, 0);
  });
  document.getElementById("header-search-close").addEventListener("click", function () {
    body.classList.remove("header-search-expanded");
    setTimeout(() => {
      body.classList.remove("header-search-open");
    }, 400);
  });
});
window.addEventListener("resize", function () {
  megaMenuPosition();
});